const createGenerateId = () => {
    let counter = 0;

    return (rule) => `gc-${rule.key}-${counter++}`;
};

export default createGenerateId;